import React, { useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Radio } from 'antd';
import { order_status } from '../statusList';

const RadioGroup = Radio.Group;

interface Props {
    status: (value: string) => void;
    current?: string;
}

const StatusDropDown = (props: Props) => {
    const [status, setStatus] = useState<string>(props?.current ? props.current : '');

    return (
        <form
            onSubmit={e => {
                e.preventDefault();
                props.status(status);
            }}
            style={{ padding: 8, width: '400px' }}
        >
            <RadioGroup
                className="grid"
                value={status}
                options={order_status}
                onChange={e => setStatus(e.target.value)}
                style={{ marginBottom: '5px' }}
            >
                {order_status.map(r => {
                    return (
                        <Radio key={r.value} value={r.value}>
                            {r.label}
                            <br />
                        </Radio>
                    );
                })}
            </RadioGroup>

            <Button
                type="primary"
                htmlType="submit"
                icon={<SearchOutlined />}
                size="small"
                style={{ width: '90px', marginRight: '8px' }}
            >
                Search
            </Button>
            <Button
                onClick={() => {
                    setStatus('');
                    props.status('');
                }}
                size="small"
                style={{ width: 90 }}
            >
                Reset
            </Button>
        </form>
    );
};

export default StatusDropDown;
